import { getCatalogData } from '../selectors';
import {
  DISPLAY_TYPE_BLOCK,
  SORT_BY_POPULARITY,
  SORT_BY_PRICE,
  SORT_BY_PRICE_DESC,
} from './constants';
import { isScreenBelow640 } from '../../common/settings/breakpoint/selectors';

const getCatalogControlsData = (state) => getCatalogData(state).controls || {};
/**
 * filters controls selectors
 */
export const getCatalogFiltersBarOpenState = (state) =>
  getCatalogControlsData(state).filtersBarOpen;
export const getCatalogFiltersBarChangedState = (state) =>
  getCatalogControlsData(state).filtersValuesChanged;

export const getCatalogActiveSortBy = (state) => getCatalogControlsData(state).sortBy;

/**
 * catalog sort values used by backend
 * FIXME: values are random, need to find real matches
 */
export const getCatalogActiveSortById = (state) => {
  switch (getCatalogActiveSortBy(state)) {
    case SORT_BY_PRICE_DESC:
      return 2;
    case SORT_BY_PRICE:
      return 1;
    case SORT_BY_POPULARITY:
    default:
      return 0;
  }
};

const sortByTypes = [
  {
    slug: SORT_BY_POPULARITY,
    label: 'По популярности',
  },
  {
    slug: SORT_BY_PRICE,
    label: 'По цене от дешевых',
  },
  {
    slug: SORT_BY_PRICE_DESC,
    label: 'По цене от дорогих',
  },
];

export const getCatalogSortByOptions = () => sortByTypes;
export const getCatalogDisplayTypeCookieName = (state) =>
  getCatalogControlsData(state).displayTypeCookieName;
export const getCatalogActiveDisplayType = (state) => getCatalogControlsData(state).displayType;
export const getCatalogDisplayIsTiled = (state) =>
  getCatalogActiveDisplayType(state) === DISPLAY_TYPE_BLOCK && !isScreenBelow640(state);

/** Parameter to make filters disabled */
export const getCatalogDisableFilters = (state) => getCatalogControlsData(state).disableFilters;

export const getCatalogForcedRemainsOnly = (state) =>
  getCatalogControlsData(state).forcedRemainsOnly || null;
